// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 8799 ? "tree-editor" : chunkId) + "-" + {"2688":"d3b8c17201dfb7f5a47e","8799":"cd40b8ff05c40f6f584b"}[chunkId] + ".chunk.js";
};